import React, { useState } from "react";
import Draggable from "react-draggable";

export const DynamicSoftCostModal = ({ onCancel, onFilterSave, selectedDynamicField = {}, isSubmitting = false, heading = null }) => {
    const [showErrorBorder, setShowErrorBorder] = useState(false);
    const [FilterData, setFilterData] = useState({
        name: selectedDynamicField?.name || ""
    });

    const validate = () => {
        setShowErrorBorder(false);
        if (!FilterData.name && !FilterData.name.trim().length) {
            setShowErrorBorder(true);
            return false;
        }
        return true;
    };
    const submitSaveFilter = () => {
        if (validate()) {
            onFilterSave(FilterData);
        }
    };
    const isEdit = selectedDynamicField?.id;
    return (
        <>
            <div className="modal modal-region modal-view inbox-modal" id="modalId" tabIndex="-1" style={{ display: "block" }}>
                <Draggable handle=".draggable" cancel=".non-draggable">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header draggable">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    <div className="txt-hed">
                                        {isEdit ? "Edit" : "Add New"} {heading ? heading : "Soft Cost"}
                                    </div>
                                </h5>
                                <button type="button" className="close non-draggable" onClick={onCancel}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className={`modal-body region-otr sm-chart-upload`}>
                                <div className="col-md-12 main-sec">
                                    <div className="form-row">
                                        <div className="form-group col-12 mb-4">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                placeholder="Name"
                                                value={FilterData.name}
                                                onChange={e => {
                                                    let value = e.target.value;
                                                    setFilterData(prevParams => {
                                                        return {
                                                            ...prevParams,
                                                            name: value
                                                        };
                                                    });
                                                }}
                                                className={`form-control ${
                                                    showErrorBorder && !FilterData.name && !FilterData.name.trim().length ? "error-border" : ""
                                                }`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-sec">
                                    <div className="text-right btnOtr edit-cmn-btn">
                                        <button
                                            type="button"
                                            className="btn btn-create save"
                                            disabled={isSubmitting}
                                            onClick={() => submitSaveFilter()}
                                        >
                                            {isEdit ? "Update" : "Add"}
                                            {isSubmitting && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btnClr mr-1"
                                            data-dismiss="modal"
                                            disabled={isSubmitting}
                                            onClick={() => onCancel()}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        </>
    );
};
